// SPDX-FileCopyrightText: 2026 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0

export {
  emptyAudioFrame,
  FakeRecognizeStream,
  FakeSTT,
  type FakeSTTOptions,
  type FakeUserSpeech,
  RecognizeSentinel,
  speedUpFakeUserSpeech,
} from './fake_stt.js';
